.item {
  display: flex;
  width: 100%;
  padding: 1px 0.375rem;
  box-sizing: border-box;
  cursor: pointer;
}
.item[aria-disabled='true'] {
  cursor: not-allowed;
}

.content {
  display: flex;
  flex: 1 1 0;
  min-width: 0;
  align-items: center;
  gap: 0.5rem;
  border-radius: 0.375rem;
  padding: 0.625rem 0.625rem 0.625rem 0.5rem;
}
.sm .content {
  padding: 0.5rem 0.625rem 0.5rem 0.5rem;
}

.item:hover .content,
.item:focus-visible .content,
.content.active {
  background: var(--surface-hover);
}
.item:focus-visible {
  outline: none;
}

.leading {
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  color: var(--text-quaternary);
}

.text {
  display: flex;
  flex: 1 1 0;
  min-width: 0;
  align-items: center;
  gap: 0.5rem;
}
.label {
  overflow: hidden;
  color: var(--text-primary);
  text-overflow: ellipsis;
  white-space: nowrap;
}
.supporting {
  flex-shrink: 0;
  color: var(--text-tertiary);
}

.check {
  flex-shrink: 0;
  color: var(--brand-solid);
}

/* ── Trailing meta (`8 labs`) — the row's end, before the check ── */
.trailing {
  flex-shrink: 0;
  color: var(--text-tertiary);
  white-space: nowrap;
}

/* ── Two-line result (label + description) ── */
.twoLine {
  align-items: flex-start;
}
.twoLine .text {
  flex-direction: column;
  align-items: flex-start;
  gap: 0;
}
/* Centre the 20 px glyph on the 24 px first line. */
.twoLine .leading {
  padding-top: 0.125rem;
}
.description {
  max-width: 100%;
  overflow: hidden;
  color: var(--text-tertiary);
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* ── Leading checkbox (multi-select rows) ── */
.checkbox {
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 1.25rem;
  height: 1.25rem;
  border: 1px solid var(--border);
  border-radius: 0.375rem;
  background: var(--surface);
  color: var(--fg-on-solid);
  box-sizing: border-box;
}
.checkboxOn {
  border-color: var(--brand-solid);
  background: var(--brand-solid);
}
.checkboxGlyph {
  display: block;
}
.content.disabled .checkbox {
  background: var(--surface-tertiary);
  border-color: var(--border);
}

@media (forced-colors: active) {
  .checkbox {
    forced-color-adjust: none;
    background: Canvas;
    border-color: CanvasText;
  }
  .checkboxOn {
    background: Highlight;
    border-color: Highlight;
    color: HighlightText;
  }
}

/* Disabled — muted, non-interactive. */
.content.disabled {
  background: transparent;
  cursor: not-allowed;
}
.content.disabled .label,
.content.disabled .supporting,
.content.disabled .trailing,
.content.disabled .description,
.content.disabled .leading {
  color: var(--text-disabled);
}

@media (forced-colors: active) {
  .content.active,
  .item:focus-visible .content {
    outline: 2px solid Highlight;
    outline-offset: -2px;
  }
}
